import _ from "lodash";
import { useCallback, useMemo, useState } from "react";
import futuresContractsService from "./futuresContracts.service";
import IsLoaded from "common/isLoaded";
import FuturesPriceUpdate from "./futuresPriceUpdate";


export type RealTimeSnapshot = IsLoaded<FuturesPriceUpdate> & { refresh: () => void };

export default function useRealTimeSnapshot(futuresContractId: number, shouldLoad: boolean): RealTimeSnapshot
{
    const refresh = useCallback(function() {
        updatePrice();
    }, []);

    const [snapshot, setSnapshot] = useState<RealTimeSnapshot>({ isLoaded: false, data: null, refresh: refresh});

    useMemo(() => {
        updatePrice();
    }, [futuresContractId, shouldLoad])

    async function updatePrice() {
        if (!shouldLoad) return;
        
        const result = await futuresContractsService.getRealTimeSnapshot(futuresContractId);
        setSnapshot(m => ({ ...m, isLoaded: true, data: result}));
    }

    
    return snapshot;
    
}